import { createSlice } from '@reduxjs/toolkit'
import { generateEntitySlices } from 'Shared/sliceHelpers'

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    name: '',
    stats: null,
  },
  reducers: {
    upsert: (s, a) => ({ ...s, ...a.payload }),
  },
}).reducer

const entitySliceNames = ['questions', 'answers']

const reducers = {
  dashboard: dashboardSlice,
  ...generateEntitySlices(entitySliceNames)
}

export default reducers
